module.exports = __webpack_public_path__ + "img/new-people-customer-order-joy.650200e8.png";